var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96201 16C5.93134 16 4.16101 15.3367 2.65101 14.01C1.14167 12.684 0.268339 11.014 0.0310059 9H1.04201C1.31401 10.72 2.09767 12.15 3.39301 13.29C4.68834 14.43 6.21134 15 7.96201 15C9.91201 15 11.566 14.321 12.924 12.963C14.282 11.605 14.9613 9.95067 14.962 8C14.9627 6.04933 14.2833 4.395 12.924 3.037C11.5647 1.679 9.91067 1 7.96201 1C6.92667 1 5.95401 1.21867 5.04401 1.656C4.13401 2.09267 3.33067 2.69433 2.63401 3.461H5.11501V4.461H0.962006V0.309H1.96201V2.697C2.73534 1.84833 3.64134 1.187 4.68001 0.713C5.71867 0.239 6.81267 0.00133333 7.96201 0C9.07067 0 10.11 0.208667 11.08 0.626C12.05 1.04333 12.8973 1.61467 13.622 2.34C14.3467 3.06533 14.918 3.91267 15.336 4.882C15.754 5.85133 15.9627 6.89067 15.962 8C15.9613 9.10933 15.7527 10.1487 15.336 11.118C14.9193 12.0873 14.348 12.9347 13.622 13.66C12.896 14.3853 12.0487 14.9567 11.08 15.374C10.1113 15.7913 9.07201 16 7.96201 16ZM11.166 11.854L7.51901 8.208V3H8.51901V7.792L11.873 11.146L11.166 11.854Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.aecf162f6cc9fc8728ab93d7673a387d.svg";
export { ForwardRef as ReactComponent };